<template>
  <div class="vue-timesheet">
    <timesheet-fieldset :layout="layoutData" @change="onChange" />
    <hr style="border-top-color: #ddd; margin: 8px 0">
    <input type="hidden" id="leftover-duration" :value="hoursDay - hoursTotal">
    <div style="display: flex; align-items: center; justify-content: space-between" v-if="!isModal">
      <div>
        <span><span style="font-weight: bold">Heures:</span> <span :style="{color: hoursTotal == hoursDay || !hasHoursDay ? '#1e9765' : '#f00'}">{{hoursTotal}}</span></span>&nbsp;&nbsp;
        <span v-if="hasHoursDay"><span style="font-weight: bold">Journée:</span> <span :style="{color: hoursTotal == hoursDay ? '#1e9765' : '#f00'}">{{hoursDay}}</span></span>
      </div>
      <div>
        <button class="btn blue" @click="sendTimesheetValidation">Envoyer</button>
        <button class="btn purple" @click="saveTimesheet">Enregistrer</button>
        <a class="btn default" :href="cancelUrl">Annuler</a>
      </div>
    </div>
  </div>
</template>

<script>
  import TimesheetFieldset from './TimesheetFieldset.vue';
  import Toastr from 'toastr';

  export default {
    name: "timesheet",
    components: { TimesheetFieldset },
    props: {
      layout: {
        type: Object,
        required: true
      },
      isModal: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        layoutData: this.layout,
        hoursTotal: 0,
        hoursDay: 0,
        hasHoursDay: true,
      }
    },
    computed: {
      cancelUrl() {
        return window.baseUrl + "timesheet";
      }
    },
    mounted () {
      setTimeout(() => {
        this.recalculateHours();
      }, 50);

      if(this.isModal) {
        $("button[data-bb-handler='save']").on("click", async (e) => {
          await this.saveTimesheet(true);
        })
        $("button[data-bb-handler='approve']").on("click", async (e) => {
          await this.approveTimesheet(true);
        })

        $(".modal-footer").append(`<div class="pull-left"><span style="font-weight: bold;">Heures:&nbsp;</span><span class="total-input-hours" style="color: rgb(30, 151, 101); font-weight: bold;">0</span>&nbsp;&nbsp;&nbsp;<span style="font-weight: bold;">Journée:&nbsp;</span><span class="day-length" style="color: rgb(30, 151, 101); font-weight: bold;">0</span></div>`)

      }
    },
    methods: {
      onChange(e,l,v,i) {
        this.recalculateHours();
      },
      recalculateHours() {
        this.hoursTotal = this.getTotalActivityHours(this.layoutData);
        this.hoursDay = this.getTotalDayHours(this.layoutData);
        $(".total-input-hours").text(this.hoursTotal)
        $(".day-length").text(this.hoursDay)
        if(this.hoursTotal != this.hoursDay) {
          $(".total-input-hours").css("color", "#971e1e")
        } else {
          $(".total-input-hours").css("color", "#38a376")
        }
      },
      getTotalActivityHours(layout, unpaid = false) {
        var total = 0;
        if(layout.type == "tabs") {
          for (const tab of layout.tabs) {
            total += this.getTotalActivityHours(tab, unpaid);
          }
        } else if(layout.fields != undefined) {
          for (const field of layout.fields) {
            total += this.getTotalActivityHours(field, unpaid);
          }
        }

        if(layout.durationValue != undefined && layout.type == "activity") {
          if(unpaid === false && layout.unpaid !== true) {
            if(layout.include_in_timesheet_hours !== false) {
              total += layout.durationValue;
              if(layout.negativeDurationValue != null) {
                total -= layout.negativeDurationValue;
              }
            }
          } else if(unpaid === true && layout.unpaid === true) {
            total += layout.durationValue;
          } else if(unpaid === false && layout.unpaid === true) {
            total -= layout.durationValue;
          } else if(unpaid === true && layout.negativeDurationValue > 0) {
            total += layout.negativeDurationValue;
          } 
        }

        return total;
      },
      getTotalDayHours(layout) {
        var startDayHour = null;
        var endDayHour = null;

        var startDayField = this.findFieldLayoutByName("timesheet_day_time_start", this.layoutData)
        var endDayField = this.findFieldLayoutByName("timesheet_day_time_end", this.layoutData)

        if(startDayField == null) {
          this.hasHoursDay = false;
          this.hoursDay = this.hoursTotal;
          return 0;
        }

        let unpaidHours = this.getTotalActivityHours(this.layoutData, true);

        startDayHour = [null,undefined].indexOf(startDayField.value) === -1 ? startDayField.value : null;
        endDayHour = [null,undefined].indexOf(endDayField.value) === -1 ? endDayField.value : null;

        if(startDayHour == null || endDayHour == null) {
          return 0 - unpaidHours;
        } else if(startDayHour == endDayHour) {
          return 24 - unpaidHours;
        } else {
          return (moment(endDayHour, "HH:mm").diff(moment(startDayHour, "HH:mm"), 'm') / 60) - unpaidHours;
        }
      },
      findFieldLayoutByName(fieldName, layout) {
        for (const field of layout.fields) {
          if(field.timesheet_column == fieldName || field.name == fieldName) {
            return field;
          } else if(field.type == "tabs") {
            for (const tab of field.tabs) {
              let find = this.findFieldLayoutByName(fieldName, tab);
              if(find != null){
                return find;
              }
            }
          } else {
            if(field.fields != undefined) {
              let find = this.findFieldLayoutByName(fieldName, field);
              if(find != null){
                return find;
              }
            }
          }
        }
        return null;
      },
      async sendTimesheetValidation() {

        let errorMessage = null;
        if(!this.validateTimesheet()) {
          errorMessage = "Veuillez revérifier la feuille de temps, corriger les erreurs et la réenvoyer.";
        } else if(this.hoursDay != this.hoursTotal && this.hasHoursDay) {
          errorMessage = "Le nombre d'heures total doit correspondre au nombre d'heures de la journée."
        }

        if(errorMessage != null) {
          bootbox.dialog({
            title: "Erreur de validation",
            message: errorMessage,
            buttons: {
              ok: {
                label: "D'accord",
                className: "blue"
              }
            }
          })
        } else {
          let success = await this.saveTimesheet(false);
          if(success) {
            await this.sendTimesheet();
          }
        }
      },
      async sendTimesheet() {
        try {
          var message_text = "<h1>Veuillez patienter</h1>";
          App.blockUI({ message: message_text, boxed: true, zIndex: 20000 });
          let response = await $.post(window.baseUrl+"timesheet/v2/send", { timesheet_id: this.layout.timesheet_id });
          App.unblockUI();
          bootbox.dialog({
            title: "Envoie avec succès!",
            message: response.message,
            buttons: {
              ok: {
                label: "Terminer",
                className: "blue",
                callback: function() {
                  window.location.href = window.baseUrl + "timesheet";
                }
              }
            }
          })
        } catch (ex) {
          App.unblockUI();
          console.error(ex);

          bootbox.dialog({
            title: "Une erreur s'est produite",
            message: ex.responseJSON.message,
            buttons: {
              ok: {
                label: "Ok",
                className: "blue"
              }
            }
          })
        }
      },
      async approveTimesheet() {
        try {
          var message_text = "<h1>Veuillez patienter</h1>";
          App.blockUI({ message: message_text, boxed: true, zIndex: 20000 });
          var filters = $("#form_filter").serialize();
          let response = await $.post(window.baseUrl+"timesheet/v2/approve", { timesheet_id: this.layout.timesheet_id, filters: filters });
          App.unblockUI();
          Toastr.success(response.message, "Succès")
          if(this.isModal) {
            $(".modal").modal("hide");
            refreshTable("timesheet_list_table", response.html);
          } else {
            window.location.href = window.baseUrl + "timesheet";
          }
        } catch (ex) {
          App.unblockUI();
          console.error(ex);

          bootbox.dialog({
            title: "Une erreur s'est produite",
            message: ex.responseJSON.message,
            buttons: {
              ok: {
                label: "Ok",
                className: "blue"
              }
            }
          })
        }
      },
      async saveTimesheet(showdialog) {
        let data = {
          timesheet: {},
          activities: [],
          materials: []
        };

        data = this.getFieldsForSave(this.layoutData, data);

        try {
          let postData = {
            timesheet_id: this.layoutData.timesheet_id,
            timesheet_timesheet_type_id: this.layoutData.timesheet_timesheet_type_id,
            version: 2, 
            timesheet_data: data
          }

          if(this.isModal) {
            postData.modal = true;
            postData.filters = $("#form_filter").serialize();
          }

          var message_text = "<h1>Sauvegarde en cours...<br>Veuillez patienter</h1>";
          App.blockUI({ message: message_text, boxed: true, zIndex: 20000 });

          let response = await $.post(window.baseUrl+"timesheet/v2/saveorcreate", postData, "json")
          if(this.isModal) {
            refreshTable("timesheet_list_table", response.html);
          } else {
            this.layoutData.timesheet_id = response.timesheet.timesheet_id;
          }

          App.unblockUI();

          if(showdialog) {
            bootbox.dialog({
              title: "Sauvegarde avec succès",
              message: "La sauvegarde de la feuille de temps s'est fait avec succès!",
              buttons: {
                ok: {
                  label: "Ok",
                  className: "blue",
                  callback: () => {
                    if(this.isModal) {
                      $(".modal").modal("hide");
                    } else {
                      window.location.href = window.baseUrl + "timesheet";
                    }
                  }
                }
              }
            })
          }

          return true;
        } catch(e) {
          App.unblockUI();
          console.error(e);

          bootbox.dialog({
            title: "Une erreur s'est produite",
            message: "La sauvegarde de la feuille de temps ne s'est pas fait avec succès. Une erreur s'est produite!",
            buttons: {
              ok: {
                label: "Ok",
                className: "blue"
              }
            }
          })

          return false;
        }
      },
      getFieldsForSave(layout, data) {

        if(layout.type == "activity" && layout.valueGroups != null && layout.enabled !== false) {
          for (const valueGroup of layout.valueGroups) {
            let activity = { 
              timesheet_activity_NA: layout.na_value,
              timesheet_activity_timesheet_activity_type_id: layout.activity_type
            }
            for (const columnName in valueGroup) {
              if (Object.hasOwnProperty.call(valueGroup, columnName) && columnName != "timesheet_activity_NA" && columnName != "timesheet_activity_timesheet_activity_type_id") {
                const value = valueGroup[columnName];
                if(value != null && (value != 0 && columnName == "timesheet_activity_hour_total" || columnName != "timesheet_activity_hour_total")) {
                  activity[columnName] = value;
                } else {
                  activity[columnName] = null;
                }
              }
            }

            data.activities.push(activity);
          }
        } else if (layout.type == "material" && layout.valueGroups != null && layout.enabled !== false) {
          for (const valueGroup of layout.valueGroups) {
            let material = { 
              timesheet_material_timesheet_material_type_id: layout.material_type,
              timesheet_material_diameter: 0
            }
            for (const columnName in valueGroup) {
              if (Object.hasOwnProperty.call(valueGroup, columnName)) {
                const value = valueGroup[columnName];
                material[columnName] = value
              }
            }
            data.materials.push(material);
          }
        } else if (["group", "root"].indexOf(layout.type) !== -1) {
          if(layout.timesheet_column != undefined) {
            let val = {};
            for(let field of layout.fields) {
              val[field.name] = field.value;
            }
            data.timesheet[layout.timesheet_column] = JSON.stringify(val);
          } else {
            for(let field of layout.fields) {
              data = this.getFieldsForSave(field, data);
            }
          }
        } else if (["tabs"].indexOf(layout.type) !== -1) {
          for(let tab of layout.tabs) {
            for(let field of tab.fields) {
              data = this.getFieldsForSave(field, data);
            }
          }
        } else if(layout.type == "collapsible_group") {
          if(layout.is_expanded == 1) {
            for (const field of layout.fields) {
              data = this.getFieldsForSave(field, data);
            }
          }
        } else if(layout.type == "field_selector") {
          for (const field of layout.fields) {
            data = this.getFieldsForSave(field, data);
          }
        } else if (layout.timesheet_column != undefined) {
          data.timesheet[layout.timesheet_column] = layout.value ?? ""
        }

        return data;
      },
      validateTimesheet() {
        var valid = this.validateLayout(this.layoutData, 0, null);
        return valid;
      },
      validateLayout(layout, value) {
        let isvalid = true;
        let usedValue = value == null ? layout.value : value;
        let valueIsEmpty = ["",null,undefined].indexOf(usedValue) !== -1;
        
        if (layout.type == "activity") {
          if (!layout.na_value && layout.enabled !== false) {
            for (const valueGroupIx in layout.valueGroups) {
              var valueGroup = layout.valueGroups[valueGroupIx]
              for (const fieldIx in layout.fields) {
                var field = layout.fields[fieldIx]
                let fieldErrors = this.validateField(field, valueGroup[field.name]);
                isvalid = fieldErrors.length == 0 && isvalid;
                if(fieldErrors.length > 0) {
                  console.log("INVALID ACT FIELD", field)
                }
                if(layout.errors == undefined) {
                  this.$set(layout, "errors", [])
                }
                if(layout.errors[valueGroupIx] == undefined) {
                  this.$set(layout.errors, valueGroupIx, {})
                }
                this.$set(layout.errors[valueGroupIx], field.name, fieldErrors)
              }
            }
          }
        } else if(layout.type == "group" || layout.type == "root") {
          for (const field of layout.fields) {
            let fieldvalid = this.validateLayout(field, null, null);
            isvalid = fieldvalid && isvalid;
            if(!fieldvalid) {
              console.log("INVALID GROUP", field)
            }
          }
        } else if(layout.type == "tabs") {
          for (const tab of layout.tabs) {
            if(tab.durationValue > 0) {
              for (const field of tab.fields) {
                let fieldvalid = this.validateLayout(field, null, null);
                isvalid = fieldvalid && isvalid;
                if(!fieldvalid) {
                  console.log("INVALID TAB GROUP", field)
                }
              }
            }
          }
        } else if(layout.type == "collapsible_group") {
          if(layout.is_expanded == 1) {
            for (const field of layout.fields) {
              let fieldvalid = this.validateLayout(field, null, null);
              isvalid = fieldvalid && isvalid;
              if(!fieldvalid) {
                console.log("INVALID COLLAPSED GROUP", field)
              }
            }
          }
        } else if(layout.type == "field_selector") {
          for (const field of layout.fields) {
            let fieldvalid = this.validateLayout(field, null, null);
            isvalid = fieldvalid && isvalid;
            if(!fieldvalid) {
              console.log("INVALID COLLAPSED GROUP", field)
            }
          }
        } else {
          let errors = this.validateField(layout, layout.value);
          isvalid = isvalid && errors.length == 0;
          if(errors.length > 0) {
            console.log("INVALID FIELD", layout)
          }
          this.$set(layout, "errors", errors)
        }

        return isvalid;
      },
      validateField(layout, value) {
        let errors = [];
        let valueIsEmpty = ["",null,undefined].indexOf(value) !== -1;
        if(layout.required && valueIsEmpty && layout.enabled !== false) {
          errors.push("Ce champ est obligatoire.");
        }
        return errors;
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>